import r from"../core/AxiosError.js";import o from"../utils.js";function e(o,e,i){r.call(this,null==o?"canceled":o,r.ERR_CANCELED,e,i),this.name="CanceledError"}o.inherits(e,r,{__CANCEL__:!0});export{e as default};
